export class ApiError extends Error {
    readonly url: string;
    readonly options: RequestInit | undefined;
    readonly status: number;
    readonly statusText: string;

    constructor(url: string, options: RequestInit | undefined, status: number, statusText: string) {
        super(`API Error ${status}: ${statusText}`);

        this.url = url;
        this.options = options;
        this.status = status;
        this.statusText = statusText;
    }
}

export type ApiCall = <T>(url: string, options?: RequestInit | undefined) => Promise<T>;

export function createApiCall(): ApiCall {
    return async <T>(url: string, options?: RequestInit | undefined) => {
        const res = await fetch(url, options);
        if (Math.ceil(res.status / 100) != 2) {
            throw new ApiError(url, options, res.status, res.statusText);
        }
        const text = await res.text();
        return JSON.parse(text) as T;
    };
}
